import { h, defineComponent, inject } from 'vue';
import { ImageAsset } from '@/ui/components/asset/ImageAsset';
import { ItemProps } from '@/ui/components/inspectionReport/types';
import { useInspectionReport } from '@/ui/components/inspectionReport/useInspectioReport';
import { isLowQualityImagesFromReportPageKey } from '@/ui/injectionKeys';
import { isPdf } from '@/ui/helpers/systemHelper';

export const Signature = defineComponent<ItemProps>({
  name: 'Signature',
  props: ['item'],
  setup(props) {
    return function render() {
      const isLowQualityImages = inject(isLowQualityImagesFromReportPageKey, false);
      let response;

      if (props.item.responded && props.item.response) {
        response = h(ImageAsset, {
          class: 'mr-3 inline-block inspection-report__image-drawing-thumbnail',
          props: {
            photo: props.item.response,
            isLowQualityImages: isPdf && isLowQualityImages,
          },
        });
      } else {
        response = null;
      }

      return h('div', {
        class: 'avoid-page-break',
      }, [
        h('div', {
          class: 'inspection-report__response-signature',
        }, [
          props.item.responded
            ? response
            : useInspectionReport().getNotRespondedAnswer(),
        ]),
      ]);
    };
  },
});
